import * as React from 'react';
import Link from '@mui/material/Link';
import Typography from '@mui/material/Typography';
import Title from './Title';

function preventDefault(event: React.MouseEvent) {
    event.preventDefault();
}

export default function Deposits() {
    return (
        <React.Fragment>
            <Title>Depósitos</Title>
            <Typography component="p" variant="h4">
                $3,024.00
            </Typography>
            <Typography color="text.secondary" sx={{ flex: 1 }}>
                20 de julio de 2022
            </Typography>
            <div>
                <Link color="primary" href="#" onClick={preventDefault}>
                    Ver más...
                </Link>
            </div>
        </React.Fragment>
    );
}